import { Tabs, useTheme } from "@mui/material";
import PropTypes from "prop-types";
import { rgba } from "polished";

export default function MyTabs({
  indicatorColor = "secondary",
  value = 0,
  onChange = () => {},
  variant = "scrollable", // scrollable, standard, fullWidth
  transparent = false,
  scrollButtons = "auto",
  centered = false,
  height = 48,
  ...props
}) {
  if (centered) variant = "standard";
  // get success color from theme
  const theme = useTheme();
  const successColor = theme.palette["success"].main;
  // eslint-disable-next-line no-unused-vars
  const infoColor = theme.palette["info"].main;
  const secondaryColor = theme.palette["secondary"].main;

  const styles = {
    tab: {
      borderRadius: "2px",
      borderTop: "2px solid rgba(128, 128, 128, 0.8)",
      borderLeft: "1px solid rgba(128, 128, 128, 0.6)",
      borderRight: "1px solid rgba(128, 128, 128, 0.6)",
      borderBottom: "none",
      boxShadow: "0px 0px 30px 30px rgba(128, 128, 128, 0.4) inset",
    },
    tabs: {
      "& button": { borderRadius: 1, transition: "all 0.4s ease-in-out" },
      "& button:hover": {
        backgroundColor: rgba(secondaryColor, 0.2),
        borderRadius: 0,
        borderColor: rgba(secondaryColor, 0.5),
      },
      "& button:active": { backgroundColor: rgba(successColor, 0.2) },
      "& .Mui-selected": {
        backgroundColor: "rgba(128, 128, 128, 0.3)",
        border: "1px solid rgba(128, 128, 128, 0.7)", //`2px solid ${secondaryColor}`, // Add border to the active tab
        borderRadius: 1,
      },
      height: height,
      minHeight: height,
      "& .MuiTabs-flexContainer": {
        height: height,
        minHeight: height,
        margin: 0,
        padding: 0,
      },
      "& .MuiTab-root": {
        minHeight: height,
        height: height,
      },
      "& .MuiTabs-scroller": {
        minHeight: height,
        height: height,
      },
    },
  };
  return (
    <Tabs
      component={"div"}
      indicatorColor={indicatorColor}
      style={transparent ? { backgroundColor: "transparent" } : styles.tab}
      sx={styles.tabs}
      value={value || 0}
      onChange={onChange}
      variant={variant} // scrollable, standard, fullWidth
      scrollButtons={scrollButtons}
      centered={centered}
      allowScrollButtonsMobile>
      {props.children}
    </Tabs>
  );
}

MyTabs.propTypes = {
  indicatorColor: PropTypes.string,
  value: PropTypes.number,
  onChange: PropTypes.func,
  children: PropTypes.node,
  variant: PropTypes.string,
  transparent: PropTypes.bool,
  scrollButtons: PropTypes.oneOf(["auto", true, false]),
  centered: PropTypes.bool,
  height: PropTypes.number,
};
